import { connect } from 'react-redux'
import { IStoreState, ITripEdit } from '../../types'
import * as actions from '../../state/actions/trips'
import ManualTripCompleteModal from '../../components/trips/ManualTripCompleteModal'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  const currentTripId = ownProps.match.params.tripId
  const currentTrip = state.trips.items[currentTripId]
  return {
    currentTripId,
    currentTrip,
    close: ownProps.history.goBack,
    loading: state.trips.isFetching
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    completeTripManually: async (
      tripId: string,
      paymentRequired: boolean,
      tripPrice?: number,
      comment?: string,
      disableNotification?: boolean
    ): Promise<any> => {
      return await dispatch(
        actions.completeTripManually(tripId, paymentRequired, tripPrice, comment, disableNotification)
      )
    },

    saveData: async (params: ITripEdit): Promise<any> => {
      return await dispatch(actions.saveData(params))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManualTripCompleteModal)



// WEBPACK FOOTER //
// ./src/containers/trips/ManualTripCompleteModal.ts